<div class="row mb-4 d-flex justify-content-center m-0 pt-2 pb-2">
  <div class="col-lg-12">
  <ckeditor class [(ngModel)]="body" [editor]="Editor" data="<p> </p>" (blur)="onChange()"></ckeditor>
</div>

</div>


